import SlidingPanel from "./SlidingPanel";

export default SlidingPanel;
